import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Ribbon";
import Intro from "@/components/Intro";
import LeadStory from "@/components/LeadStory";
import CountryDossiers from "@/components/CountryDossiers";
import Research from "@/components/Research";
import Culture from "@/components/Culture";
import Climate from "@/components/Climate";
import Trade from "@/components/Trade";
import Interviews from "@/components/Interviews";
import Multimedia from "@/components/Multimedia";
import Newsletter from "@/components/Newsletter";
import AboutPreview from "@/components/AboutPreview";
import Founder from "@/components/Founder";
import Partnership from "@/components/Partnership";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AboutPage from "@/pages/AboutPage";
import ResearchPage from "@/pages/ResearchPage";
import CountriesPage from "@/pages/CountriesPage";
import JamaicaDossierPage from "@/pages/JamaicaDossierPage";
import ArticlePage from "@/pages/ArticlePage";
import EditorialStandardsPage from "@/pages/EditorialStandardsPage";
import ContactPage from "@/pages/ContactPage";
import GhanaDossierPage from "@/pages/GhanaDossierPage";
import TrackerPage from "@/pages/TrackerPage";
import { initLenis, scrollToHash, scrollToTop } from "@/lib/lenis";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToHash(hash), 80);
      return () => clearTimeout(t);
    }
    scrollToTop();
  }, [pathname, hash]);
  return null;
};

const HomePage = () => (
  <main>
    <Hero />
    <Ribbon />
    <Intro />
    <LeadStory />
    <CountryDossiers />
    <Research />
    <Culture />
    <Climate />
    <Trade />
    <Interviews />
    <Multimedia />
    <Newsletter />
    <AboutPreview />
    <Founder />
    <Partnership />
    <Contact />
  </main>
);

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-sand font-sans text-atlantic">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/countries" element={<CountriesPage />} />
          <Route path="/countries/jamaica" element={<JamaicaDossierPage />} />
          <Route path="/countries/ghana" element={<GhanaDossierPage />} />
          <Route path="/research/cooperation-tracker" element={<TrackerPage />} />
          <Route path="/analysis/ghana-jamaica-presidential-visit" element={<ArticlePage />} />
          <Route path="/editorial-standards" element={<EditorialStandardsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
